/**
 * @prettier
 */

export function isString(variable: any): boolean {
    return typeof variable === 'string';
}
